export const DETAILS_ACCORDION_SHOW_BUTTON_TEST_ID = "details-accordion-show-button";
